<template>
  <b-modal v-model="dialogIsOpen" no-header no-footer no-close>
    <div>
      <form action="">
        <b-search-input v-model="searchTerms" />
        <div
          class="border-t border-body bg-body empty:hidden"
        >
          <b-search-results
            v-if="searchTerms.length > 0"
            :collections="collections.slice(0, 5)"
            :autocomplete="searchTerms"
            :query="searchTerms"
          />
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import BSearchInput from "~/components/navigation/search/BSearchInput.vue";
import BModal from "~/components/modal/BModal.vue";
import BSearchResults from "~/components/navigation/search/BSearchResults.vue";

interface Props {
  modelValue: boolean;
}

const emit = defineEmits(["update:modelValue", "close"]);

const props = defineProps<Props>();
const userStore = useUserStore();
const searchTerms = ref("");
const collections = ref([]);
const dialogIsOpen = ref(false);
const onKeyDown = (event: KeyboardEvent) => {
  if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
    event.preventDefault();
    emit("update:modelValue", true);
  }
};

onMounted(async () => {
  if (props.modelValue) {
    return;
  }

  window.addEventListener("keydown", onKeyDown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", onKeyDown);
});

const onClose = () => {
  searchTerms.value = "";
  emit("close");
};

watch(searchTerms, (query) => {
  collections.value = [];

  userStore.fetchUsers({
    'filter[first_name]': query,
    'filter[last_name]': query,
    limit: 5,
  }).then((response) => {
    collections.value = response.data.map((user) => ({
      name: user.first_name + ' ' + user.last_name,
      href: '/account/' + user.profile.slug,
      path: '/account/' + user.profile.slug
    }))
  })

  if (query.length === 0) {
    collections.value = [];
  }
});

watch(
  () => props.modelValue,
  () => {
    dialogIsOpen.value = props.modelValue;
  },
  { immediate: true },
);

watch(
  dialogIsOpen,
  () => {
    emit("update:modelValue", dialogIsOpen.value);
  },
  { immediate: true },
);
</script>
